export default "__VITE_ASSET__BCXOKTs8__"